import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import AppButton from "../Ui/AppButton";
import { generateOtpForPaymentAcc } from "../../../redux/user/actions";
import { Toaster } from "../../../utils/toaster";
import { APP_CONST } from "../../../config/const";

const PaymentAccountOtp = ({ onSubmit, paymentAccOtpConfig, handleClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState(null);

  const handleGenOtp = async () => {
    setIsLoading(true);
    const response = await generateOtpForPaymentAcc({ channel: "" });
    setIsLoading(false);
    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Otp Sent");
      setOtpSent(true);
    }
  };

  return (
    <Modal
      show={paymentAccOtpConfig.showOtpModal}
      className="changePasswordModal payment-account-modal"
      centered
      backdrop="static"
      keyboard={false}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        Otp verification for saving bank account
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Control
            className="mb-4"
            placeholder="Enter otp"
            onChange={(e) => setOtpValue(e.target.value)}
          />
          <div className="d-flex gap-3">
            <AppButton
              type="submit"
              onClick={() => {
                onSubmit(otpValue);
              }}
              disabled={!otpSent}
            />
            <AppButton
              type="button"
              text="Generate Otp"
              isLoading={isLoading}
              disabled={otpSent}
              onClick={handleGenOtp}
            />
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default PaymentAccountOtp;
